module.exports = __webpack_public_path__ + "static/media/equipe-tindog1.47e586c9.png";